module.exports = __webpack_public_path__ + "img/Perks-Special-Gift.95bea1ce.png";